<script>
    import rpcjs from "rpcjs";
    import Header from "./header-section.svelte";
    import Footer from "./footer.svelte";
    import { pricing, pricing_mob } from "./header_data.js";
    import Button from "./button.svelte";
    import { title } from "./store.js";
    title.set("Pricing");
    const param = window.location.href;
    const lastSegment = param.split("#").pop();

    let cards = [
        {
            icon: "/images/pricing/accurate_icon.svg",
            title: "Accurate",
            description:
                "We totally understand accuracy is important to you to achieve your project goals. We promise highly accurate estimates by employing up to date zip code based material and labor costs using RSMeans and our developed cost database.",
        },
        {
            icon: "/images/pricing/fast_icon.svg",
            title: "Fast",
            description:
                "We proud ourselved to be one of the most efficient estimating service in the market. We deliver estimates within 24 to 48 hours but our turnaround time is usually dependent upon the scope of work. This does not apply to complex industrial project estimates.",
        },
        {
            icon: "/images/pricing/affordable_icon.svg",
            title: "Affordable",
            description:
                "Due to huge estimation staff in our office, we guarantee very affordable rates that are less than the market. Our charges are dependent upon the scope of work and vary from project to project.",
        },
    ];
    let options = [
        "SINGLE TRADE PRICING",
        "PRICING FOR RESIDENTIAL & COMMERCIAL ESTIMATES",
        "PRICING FOR INDUSTRIAL ESTIMATES",
        "DEDICATED CONSTRUCTION ESTIMATOR",
    ];
    $: innerWidth = 0;
    console.log(lastSegment);
    if (lastSegment == "submit_your_project")
        requestAnimationFrame(() => {
            window.scrollTo(0, 2000);
        });
    else if (lastSegment == "submit_your_project_mob") {
        requestAnimationFrame(() => {
            let total = innerWidth + 1000;
            if (total == 1540) {
                // console.log("scrollValue",total+640);
                window.scrollTo(0, total + 640);
            } else if (total == 1414 || total == 1412) {
                // console.log("scrollValue",total+280);
                window.scrollTo(0, total + 280);
            } else if (total == 1375) {
                // console.log("scrollValue",total+150);
                window.scrollTo(0, total + 150);
            } else if (total == 1360) {
                // console.log("scrollValue",total+100);
                window.scrollTo(0, total + 100);
            } else if (total == 1390 || total == 1393) {
                // console.log("scrollValue",total+210);
                window.scrollTo(0, total + 210);
            } else {
                // console.log("scrollValue",total-150);
                window.scrollTo(0, total - 150);
            }
        });
    }
    let form_data = {
        name: "",
        email: "",
        project_scope: "",
        description: "",
    };
    let email_err=0;
    let res_message;
    let submitted=0;
    let success_msg;
    function contactRequest() {
        const { name, email, project_scope, description } = form_data;
        rpcjs.API.automason
            .save_contact_request(name, email, project_scope, description)
            .then(function (res) {
                // alert(res.message);
                success_msg=res.message;
                submitted=1;
            })
            .catch(function (res) {
                // alert(res.message);
                res_message=res.message;
                email_err=1;
            });
    }
    $: console.log(form_data);

    // function subm(){
    //     // submitted=1;
    // }
</script>

<svelte:window bind:innerWidth />
<Header
    data_desktop={pricing}
    data_mobile={pricing_mob}
    line_stroke={"white"}
    logo_color={"white"}
    logo_stroke={"white"}
    top={"100vw"}
    Width_line="19vw"
/>
<div class="desktop">
    <div>
        <div class="des">
            <h5>
                Our pricing is cost-effective, competitive, and prepared within
                prescribed deadlines.
            </h5>
        </div>
        <div style="justify-content: center; display:flex; margin-top: 1.7vw;">
            <Button
                border_radius="0.625vw"
                padding="1.042vw 3.854vw"
                title="FAQs"
                me="2"
                btnStyle="nav_bar_btn"
                px="0"
                href="/Faqs"
            />
        </div>

        <div class="cards-section">
            {#each cards as card}
                <div class="card-layout">
                    <div class="icon-text">
                        <div class="img-section">
                            <img src={card.icon} alt="" width="100%" />
                        </div>
                        <div class="text">
                            <h2 style="font-weight: 600; margin: 0;">
                                {card.title}
                            </h2>
                        </div>
                    </div>
                    <div class="card-des">
                        <h5>{card.description}</h5>
                    </div>
                </div>
            {/each}
        </div>

        <div class="contact-us" id="submit_your_project">
            <div class="overlay">
                <div
                    class="Get-in-Touch"
                    style="height:52.083vw; background-image: url('/images/pricing/get-in_touch.png');"
                >
                    <div class="after">
                        <div class="dotted-img">
                            <img
                                src="/images/pricing/get_in_touch.svg"
                                alt=""
                            />
                        </div>
                        <div class="contact-us-card">
                            <div class="card-lines">
                                <div
                                    class="contact-icon"
                                    style="padding-top: 0.27vw;"
                                >
                                    <img
                                        src="/images/submit_your_plan/location_icon.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    class="contact-text"
                                    style="margin-bottom: 1.5vw;"
                                >
                                    <p style="font-weight: 500; margin: 0;">
                                        44 East 3rd Ave, San Mateo, CA 94401
                                    </p>
                                </div>
                            </div>
                            <div class="card-lines">
                                <div class="contact-icon">
                                    <img
                                        src="/images/submit_your_plan/phone_icon.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div class="contact-text">
                                    <p style="font-weight: 500; margin: 0;">
                                        512 537 5153
                                    </p>
                                </div>
                            </div>
                            <div class="card-lines">
                                <div class="contact-icon">
                                    <img
                                        src="/images/submit_your_plan/mail.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div class="contact-text">
                                    <address>
                                        <a
                                            style="font-size: 1.042vw; font-weight: 500; margin: 0; color:#3C88C3; font-style: normal;"
                                            href="mailto:hello@automason.ai"
                                        >
                                            hello@automason.ai
                                        </a>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="submit-project">
                <div class="title">
                    <div class="title-img">
                        <img
                            src="/images/pricing/dots_lines.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="title-text">
                        <h1 style="font-size: 2.083vw; color:white; margin:0;">
                            Submit your Project
                        </h1>
                    </div>
                </div>
                {#if submitted!=1}
                <form
                    id="contact-req"
                    class="form-section"
                    on:submit|preventDefault={contactRequest}
                >
                    <input
                        class="input"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Full Name..."
                        bind:value={form_data.name}
                    />
                    <br />

                    <input
                        class="input"
                        type="text"
                        id="email"
                        name="Email"
                        placeholder="Email..."
                        bind:value={form_data.email}
                    />
                    <br />
                    {#if email_err==1}
                    <span 
                    style="color:red; text-decoration:underline; margin-left:10vw;">
                    {res_message}
                </span>
                    {/if}
                    <select
                        class="form-select"
                        bind:value={form_data.project_scope}
                        required
                    >
                        <option value="" disabled selected>Project Scope</option
                        >
                        {#each options as option}
                            <option value={option}>
                                {option}
                            </option>
                        {/each}
                    </select>
                    <textarea
                        type="text"
                        placeholder="Describe your Request..."
                        bind:value={form_data.description}
                    />
                    <div class="sub-bnt">
                        <Button
                            border_radius="0.625vw"
                            padding="1.042vw 3.073vw"
                            title="Submit"
                            me="2"
                            btnStyle="submit_btn"
                            px="0"
                        />
                    </div>
                </form>
                {:else}
                <div class="smsg">
                    <h1>{success_msg}</h1>
                    <h1>We will reach back soon.</h1>
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>

<div class="mobile">
    <div>
        <div class="des">
            <h5 style="font-size: 3.271vw;">
                Our pricing is cost-effective, competitive, and prepared within
                prescribed deadlines.
            </h5>
        </div>
        <div
            style="justify-content: center;
                    display: flex;
                    margin-top: 12.7vw;"
        >
            <Button
                border_radius="2.804vw"
                padding="1.636vw 9.579vw"
                title="FAQs"
                me="2"
                btnStyle="nav_bar_btn_mobile"
                px="0"
                href="/Faqs"
            />
        </div>

        <div class="cards-section">
            {#each cards as card, id}
                <div class="card-layout">
                    <div class="icon-text">
                        <div class="img-section">
                            <img src={card.icon} alt="" width="100%" />
                        </div>
                        {#if id == 2}
                            <div class="text" style="padding-top: 1.8vw;">
                                <h2
                                    style="font-weight: 600; margin: 0; font-size: 5.607vw;"
                                >
                                    {card.title}
                                </h2>
                            </div>
                        {:else}
                            <div class="text">
                                <h2
                                    style="font-weight: 600; margin: 0; font-size: 5.607vw;"
                                >
                                    {card.title}
                                </h2>
                            </div>
                        {/if}
                    </div>
                    <div class="card-des">
                        <h5 style="font-size: 3.271vw;">{card.description}</h5>
                    </div>
                </div>
            {/each}
        </div>
        <div class="contact-us" id="submit_your_project_mob">
            <div class="image_part">
                <div class="image-wrraper">
                    <img
                        src="/images/submit_your_plan/background.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div class="get-in-touch-text">
                    <img
                        src="/images/submit_your_plan/get_in_touch.svg"
                        alt=""
                    />
                </div>

                <div class="contact-us-card">
                    <div class="card-lines">
                        <div class="contact-icon" style="padding-top: 2vw;">
                            <img
                                src="/images/submit_your_plan/location_icon.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div
                            class="contact-text"
                            style="margin-bottom: 2.374vw;"
                        >
                            <p
                                style=" font-size:3.028vw; font-weight: 500; margin: 0;"
                            >
                                44 East 3rd Ave, San Mateo, CA 94401
                            </p>
                        </div>
                    </div>
                    <div class="card-lines">
                        <div class="contact-icon">
                            <img
                                src="/images/submit_your_plan/phone_icon.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="contact-text" style="padding-top: -1vw;">
                            <p
                                style=" font-size:3.028vw; font-weight: 500; margin: 0;"
                            >
                                512 537 5153
                            </p>
                        </div>
                    </div>
                    <div class="card-lines">
                        <div class="contact-icon" style="padding-top: 0.7vw;">
                            <img
                                src="/images/submit_your_plan/mail.svg"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="contact-text">
                            <address>
                                <a
                                    style=" font-size:3.028vw; font-weight: 500; margin: 0; color:#3C88C3; font-style: normal;"
                                    href="mailto:hello@automason.ai"
                                >
                                    hello@automason.ai
                                </a>
                            </address>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form_part">
                <div class="submit-project-title">
                    <img
                        src="/images/submit_your_plan/submit_project.svg"
                        alt=""
                    />
                </div>
                {#if submitted!=1}
                <form
                    class="form-section"
                    on:submit|preventDefault={contactRequest}
                >
                    <input
                        class="input"
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Full Name..."
                        bind:value={form_data.name}
                    />
                    <br />
                    {#if email_err==1}
                    <span style="color: red;
                    text-decoration: underline;
                    margin-left: 7vw;
                    font-size: 2.5vw;
                    top: 53vw;
                    position: relative;">{res_message}</span>
                    {/if}
                    <input
                        style="top:46.765vw"
                        class="input"
                        type="text"
                        id="email"
                        name="Email"
                        placeholder="Email..."
                        bind:value={form_data.email}
                    />
                    <br />

                    <select
                        class="form-select"
                        bind:value={form_data.project_scope}
                        required
                    >
                        <option value="" disabled selected>Project Scope</option
                        >
                        {#each options as option}
                            <option value={option}>
                                {option}
                            </option>
                        {/each}
                    </select>
                    <textarea
                        type="text"
                        placeholder="Describe your Request..."
                        bind:value={form_data.description}
                    />
                    <div class="sub-bnt">
                        <Button
                            border_radius="1.916vw"
                            padding="2.9vw 10.047vw"
                            title="Submit"
                            me="2"
                            btnStyle="submit_btn_mobile"
                            px="0"
                        />
                    </div>
                </form>
                {:else}
                <div class="smsg-mob" style="text-align: center;
                margin-top: 53vw;">
                    <h1 style="font-size: 7.125vw;">{success_msg}</h1>
                    <h1 style="font-size: 7.125vw;">We will reach back soon.</h1>
                </div>
                {/if}
            </div>
        </div>
    </div>
</div>
<Footer />

<style>
    .des {
        width: 72.396vw;
        height: 3.125vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 3.698vw;
        text-align: center;
    }
    .cards-section {
        display: flex;
        flex-direction: row;
        gap: 1.042vw;
        justify-content: center;
        margin-top: 3.698vw;
        margin-bottom: 3.125vw;
    }
    .card-layout {
        background-color: #fff4db;
        width: 20.313vw;
        height: 26.771vw;
        border-radius: 1.042vw;
    }
    .icon-text {
        display: flex;
        gap: 0.781vw;
        margin-top: 3.592vw;
        justify-content: center;
        margin-bottom: 2.24vw;
    }
    .img-section {
        width: 1.831vw;
        height: 1.831vw;
    }
    .card-des {
        width: 14.844vw;
        text-align: center;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }
    .smsg{
        margin-top: 7vw;
        text-align: center;
        font-family: 'Poppins';
    }
    .contact-us {
        display: flex;
    }
    .Get-in-Touch {
        width: 54.323vw;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .overlay {
        position: relative;
        display: flex;
        width: 54.323vw;
        height: 52.083vw;
    }
    .after {
        z-index: 1;
        position: relative;
    }
    .overlay::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 54.323vw;
        height: 52.083vw;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .dotted-img {
        position: absolute;
        width: 13.438vw;
        height: 2.813vw;
        top: 26.5vw;
        left: 7vw;
    }
    .dotted-img img {
        width: 100%;
        height: 100%;
    }
    .submit-project {
        width: 45.677vw;
        background-color: #ff6d24;
    }
    .contact-us-card {
        position: absolute;
        top: 30.5vw;
        left: 2.813vw;
        width: 23.594vw;
        height: 14.5vw;
        border-radius: 1.042vw;
        background-color: white;
        display: flex;
        flex-direction: column;
        gap: 1vw;
        padding-top: 3.229vw;
    }
    .card-lines {
        display: flex;
        gap: 1.875vw;
        flex-direction: row;
        margin-left: 2.292vw;
    }
    .contact-icon {
        width: 1.406vw;
        height: 1.771vw;
    }
    .contact-text {
        width: 13.01vw;
        height: 3.229vw;
    }
    address:hover {
        pointer-events: none;
    }
    .title-img {
        margin-left: 11.719vw;
        margin-top: 9.167vw;
        width: 20.781vw;
    }
    .title-text {
        margin-left: 12.7vw;
        margin-top: -4.1vw;
    }
    .form-section {
        margin-top: 3.542vw;
    }
    .input {
        width: 23.2vw;
        height: 3.646vw;
        border: 0.11vw solid white;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        display: flex;
        background: transparent;
        color: white;
        border-radius: 0.3vw;
    }
    input[type="text"] {
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        padding-left: 1.771vw;
        background-color: transparent;
    }
    input:focus {
        outline: none;
    }
    input:focus::placeholder {
        color: transparent;
    }
    ::placeholder {
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
    }
    textarea {
        width: 23.6vw;
        height: 8.55vw;
        border: 0.11vw solid white;
        margin-top: 1.563vw;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        display: flex;
        background: transparent;
        border-radius: 0.3vw;
        padding-left: 1.5vw;
        padding-top: 1vw;
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
    }
    textarea::placeholder {
        background-color: transparent;
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
    }
    textarea:focus {
        width: 23.6vw;
        height: 8.55vw;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        outline: none;
        background-color: transparent;
        padding-left: 1.5vw;
        padding-top: 1vw;
    }
    textarea:focus::placeholder {
        color: transparent;
    }
    textarea::after {
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        padding-left: 1.771vw;
        background-color: transparent;
    }
    .form-select {
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        padding-left: 1.5vw;
        padding-right: 1.5vw;
        width: 25.4vw;
        height: 4.3vw;
    }
    option {
        color: #000000;
    }
    select {
        background: url("/images/pricing/drop_down.svg");
        -webkit-appearance: none;
        background-size: 1vw;
        background-repeat: no-repeat;
        background-position: right 1.1vw center;
        border: 0.11vw solid white;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        display: flex;
        border-radius: 0.3vw;
    }
    select:focus {
        background: url("/images/pricing/drop_up.svg");
        background-size: 1vw;
        background-repeat: no-repeat;
        background-position: right 1.1vw center;
        outline: none;
    }
    .sub-bnt {
        display: flex;
        margin-top: 3.125vw;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .des {
            width: 71.495vw;
        }
        .cards-section {
            flex-direction: column;
            gap: 2.336vw;
            margin-top: 10.019vw;
            margin-bottom: 13.318vw;
            align-items: center;
        }
        .card-layout {
            width: 79.439vw;
            height: 65.916vw;
            border-radius: 4.673vw;
        }
        .icon-text {
            gap: 4.089vw;
            margin-top: 6.542vw;
            margin-bottom: 3.542vw;
        }
        .img-section {
            width: 5.374vw;
            height: 5.374vw;
            align-self: center;
        }
        .card-des {
            width: 60.514vw;
        }
        .contact-us {
            width: 100vw;
            height: 231.542vw;
            position: relative;
            overflow: hidden;
            flex-direction: column-reverse;
        }
        .image_part {
            width: 100vw;
            height: 96.028vw;
        }
        .image-wrraper {
            width: 100vw;
            height: 96.028vw;
        }
        .image-wrraper img {
            width: 100%;
            height: 100%;
        }
        .form_part {
            background-color: #ff6d24;
            width: 100vw;
            height: 135.514vw;
        }
        .submit-project-title {
            width: 54.93vw;
            justify-content: center;
            position: absolute;
            left: 20.561vw;
            top: 10.621vw;
        }
        .submit-project-title img {
            width: 100%;
            height: 100%;
        }
        .form-section {
            margin-top: 0;
            position: absolute;
        }
        .input {
            width: 77.075vw;
            height: 12.077vw;
            border: 0.39vw solid white;
            border-radius: 0.863vw;
            position: absolute;
            top: 28.297vw;
            left: 8vw;
            margin-left: 0;
            margin-right: 0;
            justify-content: unset;
            display: unset;
        }
        input[type="text"] {
            font-size: 2.589vw;
            padding-left: 5.743vw;
        }
        ::placeholder {
            font-size: 2.589vw;
        }
        .form-select {
            font-size: 2.589vw;
            padding-left: 5.6vw;
            padding-right: 0;
            width: 84vw;
            height: 13.077vw;
            position: absolute;
            top: 65.175vw;
            left: 8vw;
        }
        select {
            background-size: 3vw;
            background-position: right 3.794vw center;
            border: 0.39vw solid white;
            border-radius: 0.863vw;
        }
        select:focus {
            background-size: 3vw;
            background-position: right 3.794vw center;
        }
        textarea {
            position: absolute;
            top: 78.175vw;
            left: 8vw;
            width: 78vw;
            height: 31.229vw;
            border: 0.39vw solid white;
            border-radius: 0.863vw;
            padding-left: 5.6vw;
            margin-top: 5.175vw;
            padding-top: 2.336vw;
            font-size: 2.589vw;
        }
        textarea::placeholder {
            font-size: 2.589vw;
        }
        textarea:focus {
            width: 78vw;
            height: 31.229vw;
            font-size: 2.589vw;
            padding-left: 5.6vw;
            padding-top: 2.336vw;
        }
        textarea::after {
            padding-left: 5.6vw;
            font-size: 2.589vw;
        }
        .sub-bnt {
            display: unset;
            margin-top: 0;
            margin-left: 0;
            margin-right: 0;
            justify-content: unset;
            position: absolute;
            top: 122vw;
            left: 34vw;
        }
        .get-in-touch-text {
            width: 38.318vw;
            position: absolute;
            top: 142.411vw;
            left: 28.505vw;
        }
        .get-in-touch-text img {
            width: 100%;
            height: 100%;
        }
        .contact-us-card {
            position: absolute;
            top: 156.674vw;
            left: 16.589vw;
            width: 66.822vw;
            height: 40.869vw;
            background-color: white;
            display: flex;
            flex-direction: column;
            border-radius: 4.673vw;
            gap: 2.374vw;
            padding-top: 10.748vw;
        }
        .card-lines {
            gap: 5.14vw;
            margin-left: 5.14vw;
        }
        .contact-icon {
            width: 4.206vw;
            height: 4.206vw;
        }
        .contact-text {
            width: 43.692vw;
            height: 9.346vw;
        }
    }
</style>
